export default "__VITE_ASSET__PjU7tpV3__"